import React from 'react';
import ReactHowler from 'react-howler';

const buttonStyles = {
    background: 'none',
    border: 'none'
}

const PointAudioButtons = (props) => {
    return (
        <div className="point-actions">
                        <div className="point-audio">
            <ReactHowler
                src={[props.audioFile]}
                playing={props.isAudioPlaying} />

            <div style={{ position: 'relative' }}>
                <button
                    onClick={props.onPlayPrevTrack}
                    style={buttonStyles}>
                    <i
                        className="fa fa-step-backward"
                        aria-hidden="true"></i>
                </button>
                <button
                    className="playIcon"
                    onClick={props.onPlayAudio}>
                    {props.isAudioPlaying === true ? <i className="fa fa-pause" aria-hidden="true"></i> : <i className="fa fa-play" aria-hidden="true"></i>}
                </button>
                <button
                    onClick={props.onPlayNextTrack}
                    style={buttonStyles}>
                    <i
                        className="fa fa-step-forward"
                        aria-hidden="true"></i>
                </button>
            </div>
        </div>
        </div>

    )
};

export default PointAudioButtons;


// WEBPACK FOOTER //
// ./src/components/shared/PointAudio/PointAudioButtons.js